export default __webpack_public_path__ + "static/media/5.0ea3e28c.pdf";